import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { FitnessActivity, ImageMedia } from '../../../../types/__generated__';
import { onlyImages } from '../../../utils/typeGuards';
import { ImageGridWithLightbox } from '../../ImageGrid';
import { LazyLoader } from '../../LazyLoader/LazyLoader';
import { FitnessMessage } from '../Fitness/FitnessMessage';

import timelineStyles from '../Timeline.scss';
import timelineEntryStyles from '../TimelineEntry/TimelineEntry.scss';

// Lazy loading the StravaMap as react-leaflet only works on client side
// and it loads the mapping library and css for leaflet so is only needed
// when rendering a map
const FitnessMapLazy = React.lazy(() => import('../Fitness/FitnessMap'));

interface BodyProps {
  fitnessActivity?: FitnessActivity | null;
  message?: string | null;
  media?: any;
}

export const Body: FunctionComponent<BodyProps> = ({
  fitnessActivity,
  media,
  message,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  const images = media?.filter(onlyImages);
  const mapPolyline = fitnessActivity?.mapPolyline;

  return (
    <div className={timelineStyles.body}>
      {fitnessActivity ? (
        <FitnessMessage
          message={message}
          caption={t('timeline.fitnessMessage.caption')}
          fitness={fitnessActivity}
        />
      ) : (
        <div className={timelineEntryStyles.bodyMessage}>{message}</div>
      )}
      {mapPolyline ? (
        <LazyLoader>
          <div
            className={timelineEntryStyles.mapContainer}
            data-qa={'fitness-map-wrapper'}
          >
            <FitnessMapLazy polyline={mapPolyline} />
          </div>
        </LazyLoader>
      ) : null}
      {images && images.length > 0 && (
        <ImageGridWithLightbox
          gridType="template"
          className={timelineEntryStyles.bodyGallery}
          images={images.map((m: ImageMedia) => ({
            ...m,
            loading: false,
            id: m.id,
            type: m.__typename,
            url: m.url || '',
          }))}
        />
      )}
    </div>
  );
};

Body.displayName = 'TimelineEntryBody';
